import React, { useState, useEffect, useContext } from 'react';
import {format} from "date-fns";

import * as fkn from "../../../lib/fkn";
import * as net from "../../../lib/net";

import Dt_Cal from "../../../lib/ui/dt_cal";
import Tr00_Open from "./fkn/tr00_open";
import Hbok_Per from "./fkn/hbok_per";
import Hbok_Vs from "./fkn/hbok_vs";
import Eko_Recover from "./fkn/eko_recover";
import Dd_Sel from "../../../lib/ui/dd_sel";
import * as utils from "../../../assets/utils";
import Wnd_Error from "../../../lib/ui/wnd_error";
import Wnd_Ok from "../../../lib/ui/wnd_ok";
import Wnd_Info from "../../../lib/ui/wnd_info";
import Wnd_Confirm from "../../../lib/ui/wnd_confirm";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Eko_Hbok extends React.Component {
  constructor(props, context) {
    super(props);

    this.dt_fd = React.createRef();
    this.dt_td = React.createRef();

    this.store = props.store;
    this.pms = props.store.pms;

    this.state = { pgid: 11, tra: [], tsa: [], tta: [] };
    this.state.fkn = "";
    this.state.sortid = "";

    this.state.today = new Date();
    var dts = format(this.state.today, "yyyy-MM-dd");
    this.state.fdat = dts;
    this.state.tdat = dts;
    if(this.pms.base) {
        this.state.fdat = this.pms.base.fdat;
        this.state.tdat = this.pms.base.tdat;
    }
      this.state.msg = {};
      this.state.wnds = {};

      this.xselitems = [
          {fkn: 'F', text: 'RECOVER F'},
          {fkn: 'rack', text: 'RECOVER R'},
          {fkn: 'kort', text: 'RECOVER Kort'},
          {fkn: 'reg', text: 'RECOVER Register'},
          {fkn: 'pres', text: 'RECOVER Presentkort'},
          {fkn: 'ptyp', text: 'SET PTyp'}
      ];
      this.selitems = [
          { fkn: 'recov', text: 'Ekonomi Recover' },
          { fkn: 'hbokper', text: 'Huvudbok Period' },
          { fkn: 'hbokvs', text: 'Huvudbok vs Transaktioner' }
      ];
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    //this.trans();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      css.overflow = "auto";
      return css;
  }
  th_style(id) {
      var css = {};
      css.cursor = "pointer";
      if(id == this.state.sortid) css.color = "#080";
      return css;
  }
    row_style(row) {

        var css = {};
        if(row.e0typ == "xx") {
            css.background = "#3c983c";
            css.color = "#fff";
        }
        if(this.state.fkn == "F") {
            if(row.e0kontonr.substr(0, 1) !== "3") {
                css.display = "none";
            }
        }
        if(this.state.fkn == "T") {
            if(row.e0kontonr.substr(0, 1) !== "2") {
                css.display = "none";
            }
        }
        if(this.state.fkn == "B") {
            if(row.e0kontonr.substr(0, 1) !== "1") {
                css.display = "none";
            }
        }
        return css;
    }
    onUnitChange(e) {
        this.setState({unit: e.value});
  }
  dt_fdat(e) {
    //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ fdat: dts });
  }
  dt_tdat(e) {
      //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ tdat: dts });
  }
  oneday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_td.current.updateDt(this.state.fdat);
  }
  addday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateAdd();
    this.dt_td.current.updateAdd();
  }
  subday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateSub();
    this.dt_td.current.updateSub();
  }

  change_fkn(e) {
    //let cdat = this.state.seldate;
    //alert(JSON.stringify(e));
    let fkn = e.target.value;
    this.setState({fkn: fkn});
    //this.setState({tra: [], tsa: [], tta: [] });
  }

  dt_fkn() {
    var self = this;

      var msg = { info: true, text: "Hämtar huvudboks rader ..."};
      self.setState({ msg: msg });
    var prm = {};
    prm.req = "pms.eko_red.red_hbok";
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rco.tot));

        if(ret.ok != "000") {
            return;
        }
        self.setState({tra: ret.rca, msg: {} }, function () {
            self.syncTb("hbokTable");
        });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
    }
  hbok_recov(typ) {
    var self = this;

    var prm = {};
    prm.req = "pms.eko_recov.hbok_recov";
    prm.datum = this.state.fdat;
    prm.tdat = this.state.tdat;
    if(typ == "kort") {
        prm.typ = "P";
        prm.ttyp = "kort";
        prm.kontonr = "1580";
    }
    if(typ == "rack") {
        prm.typ = "S";
        prm.ttyp = "rack";
        prm.kontonr = "3055";
    }
    if(typ == "F") {
        prm.typ = "S";
        prm.ttyp = "F   ";
        prm.kontonr = "3055";
    }

    net.sio_req(prm)
    .then(function(ret){
        alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            return;
        }
        //self.setState({tra: ret.rca });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
    }
  hbok_reg_recov() {
    var self = this;

    var prm = {};
    prm.req = "pms.eko_recov.hbok_reg_recov";
    prm.datum = this.state.fdat;
    prm.tdat = this.state.tdat;

    net.sio_req(prm)
    .then(function(ret){
        alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            return;
        }
        //self.setState({tra: ret.rca });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
    }
  hbok_ptyp() {
    var self = this;

    var prm = {};
    prm.req = "pms.eko_recov.hbok_ptyp";
    prm.datum = this.state.fdat;
    prm.tdat = this.state.tdat;

    net.sio_req(prm)
    .then(function(ret){
        alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            return;
        }
        //self.setState({tra: ret.rca });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
    }
    trs_recov(typ) {
        var self = this;

        var prm = {};
        prm.req = "pms.eko_recov.trs_recov";
        prm.datum = this.state.fdat;
        prm.tdat = this.state.tdat;
        if(typ == "xx") {
            prm.typ = "S";
            prm.ttyp = "Rpru";
            prm.kontonr = "";
        }

        net.sio_req(prm)
        .then(function(ret){
            alert(JSON.stringify(ret));

            if(ret.ok != "000") {
                return;
            }
            //self.setState({tra: ret.rca });
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }

  tr_edit(row) {
    var self = this;
    var wnds = {};
    wnds.tropen = true;
    wnds.tro = row;
    this.setState({ wnds: wnds });
  }
    hbok_vs() {
        var self = this;
        var wnds = {};
        wnds.hbokvs = true;
        wnds.fdat = this.state.fdat;
        wnds.tdat = this.state.tdat;
        this.setState({ wnds: wnds });
    }
    hbok_per() {
        var self = this;
        var wnds = {};
        wnds.hbokper = true;
        wnds.fdat = this.state.fdat;
        wnds.tdat = this.state.tdat;
        this.setState({ wnds: wnds });
    }
    eko_recov() {
        var self = this;
        var wnds = {};
        wnds.ekorecov = true;
        wnds.fdat = this.state.fdat;
        wnds.tdat = this.state.tdat;
        this.setState({ wnds: wnds });
    }
    sel_fkn(sel) {
        //alert(JSON.stringify(fkn));
        if(sel.fkn == "recov") {
            this.eko_recov();
        }
        if(sel.fkn == "hbokvs") {
            this.hbok_vs();
        }
        if(sel.fkn == "hbokper") {
            this.hbok_per();
        }
      if(sel.fkn == "pres") {
          this.trs_recov("");
      }
      if(sel.fkn == "F") {
          this.hbok_recov("F");
      }
      if(sel.fkn == "rack") {
          this.hbok_recov("rack");
      }
      if(sel.fkn == "kort") {
        this.hbok_recov("kort");
      }
      if(sel.fkn == "reg") {
        this.hbok_reg_recov();
      }
      if(sel.fkn == "ptyp") {
        this.hbok_ptyp();
      }
  }
    syncTb(tb){
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');

        for (let i = 0; i < thElements.length; i++) {
            if(!thElements[i]) continue;
            if(!tdElements[i]) continue;
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
   tb_sort(typ) {
      var self = this;
      //var rvs = self.state.rvs;
      var tra = self.state.tra;
      var sz = this.state.sz_val;

      tra.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
      self.setState({ tra: tra, sortid: typ });
   }
  tb_filtr() {
      var self = this;
      var rvs = self.state.rvs;
      var sz = this.state.sz_val;

      if(sz.length < 1) {
        self.setState({ rva: rvs });
          return;
      }
      sz = sz.toUpperCase();
      var rva = rvs.filter(function(row) {
            var brc = false;
            if(row.company.toUpperCase().includes(sz)) brc = true;
            if(row.name.toUpperCase().includes(sz)) brc = true;
            return brc;
      });
      self.setState({rva: rva });
   }

  render() {
    return (
    <div className="web-app">

    <div className="flex-row flex-space-between">
        <div className="flex-row">
        <div className="flex-row">
              <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
              <Dt_Cal dts={ this.state.fdat } rp="1" ref={this.dt_fd} getValue={(e)=> this.dt_fdat(e)} />
              <div className="dt-btn-01" onClick={() => this.oneday() } >1</div>
              <Dt_Cal dts={ this.state.tdat } rp="1" ref={this.dt_td} getValue={(e)=> this.dt_tdat(e)} />
              <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
        </div>
            <select className="form-control sel_input" placeholder="Välj funktion" value={this.state.fkn} onChange={(e) => this.change_fkn(e)} >
                <option value="">ALLA</option>
                <option value="F">FÖRSÄLJNING</option>
                <option value="T">TRANSPORT</option>
                <option value="B">BETALNINGAR</option>
            </select>
        </div>
        <div className="flex-row">
        <button className="btn btn-hw-blue w150" onClick={() => this.dt_fkn() } aria-label="System" >
            Visa
        </button>
        <Dd_Sel items={ this.selitems } cls="web-x-icon" getValue={(e)=> this.sel_fkn(e)} />
        </div>
    </div>
    <div className="divider_green"></div>

        <div id="hbokTable">
          <table className="table table-bordered table-hover" style={{marginBottom: "0px"}}>
                <thead>
                <tr>
                    <th style={ this.th_style("e0datum") } onClick={() => this.tb_sort("e0datum") }>Datum</th>
                    <th style={ this.th_style("e0kontonr") } onClick={() => this.tb_sort("e0kontonr") }>Konto</th>
                    <th style={ this.th_style("e0typ") } onClick={() => this.tb_sort("e0typ") }>Typ</th>
                    <th style={ this.th_style("e0tid") } onClick={() => this.tb_sort("e0tid") }>Tid</th>
                    <th style={ this.th_style("e0text") } onClick={() => this.tb_sort("e0text") }>Text</th>
                    <th style={ this.th_style("e0antal") } onClick={() => this.tb_sort("e0antal") }>Antal</th>
                    <th style={ this.th_style("e0pris") } onClick={() => this.tb_sort("e0pris") }>Pris</th>
                    <th style={ this.th_style("e0moms") } onClick={() => this.tb_sort("e0moms") }>Moms</th>
                    <th style={ this.th_style("e0tkn") } onClick={() => this.tb_sort("e0tkn") }>Tkn</th>
                    <th style={ this.th_style("e0rumsnr") } onClick={() => this.tb_sort("e0rumsnr") }>Rum</th>
                    <th style={ this.th_style("e0ptyp") } onClick={() => this.tb_sort("e0ptyp") }>PTyp</th>
                </tr>
                </thead>
            </table>
            <div style={ this.tb_style() }>
          <table className="table table-bordered table-hover">
            <tbody>
                { this.state.tra.map((row, key) =>
                    <tr key={key} style={ this.row_style(row) } onDoubleClick={() => this.tr_edit(row) }>
                        <td>{ utils.toDate( row.e0datum ) }</td>
                        <td>{ row.e0kontonr }</td>
                        <td>{ row.e0typ }</td>
                        <td>{ utils.toTid( row.e0tid ) }</td>
                        <td>{ utils.toLang( row.e0text ) }</td>
                        <td>{ utils.toNum( row.e0antal ) }</td>
                        <td>{ utils.toPris( row.e0pris ) }</td>
                        <td>{ row.e0moms }</td>
                        <td>{ row.e0tkn }</td>
                        <td>{ utils.toRumsnr( row.e0rumsnr ) }</td>
                        <td>{ row.e0ptyp }</td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
        </div>
        { this.state.wnds.tropen ? <Tr00_Open wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.hbokvs ? <Hbok_Vs wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.hbokper ? <Hbok_Per wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.ekorecov ? <Eko_Recover wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        <Wnd_Error msg={this.state.msg} ctx={this} />
        <Wnd_Ok msg={this.state.msg} ctx={this} />
        <Wnd_Info msg={this.state.msg} ctx={this} />
        <Wnd_Confirm msg={this.state.msg} ctx={this} />

    </div>
  );
}
}
export default Eko_Hbok;
